const YMD_RE = /^\d{4}-\d{2}-\d{2}$/

function parseCsvLine(line) {
  const result = []
  let current = ''
  let inQuotes = false

  for (let i = 0; i < line.length; i++) {
    const char = line[i]
    const nextChar = line[i + 1]

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"'
        i += 1
      } else {
        inQuotes = !inQuotes
      }
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim())
      current = ''
    } else {
      current += char
    }
  }

  result.push(current.trim())
  return result
}

function isStrictYmd(value) {
  const raw = String(value || '').trim()
  if (!YMD_RE.test(raw)) return false
  const [year, month, day] = raw.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  )
}

/**
 * Reject upcoming-promotion CSV rows whose start or end is not yyyy-mm-dd.
 * Returns an error message, or null when every dated row is valid.
 */
export function upcomingPromotionCsvDateError(csvText) {
  const lines = String(csvText || '')
    .replace(/^\uFEFF/, '')
    .split(/\r\n|\r|\n/)
    .map((line) => line.trim())
    .filter(Boolean)

  if (lines.length < 2) return null

  const headers = parseCsvLine(lines[0]).map((header) =>
    String(header || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_'),
  )
  const startIndex = headers.indexOf('start')
  const endIndex = headers.indexOf('end')
  if (startIndex < 0 || endIndex < 0) return null

  for (let i = 1; i < lines.length; i++) {
    const values = parseCsvLine(lines[i])
    const start = String(values[startIndex] || '').trim()
    const end = String(values[endIndex] || '').trim()
    if (!start && !end) continue
    if (!isStrictYmd(start) || !isStrictYmd(end)) {
      return `Row ${i + 1}: start and end must be yyyy-mm-dd`
    }
  }

  return null
}
